import BaseSetup from '@/components/BaseSetup';
import { Reactive } from '@/utils/decorators';
import { useNotif } from '@orion.ui/orion';
import { AxiosResponse } from 'axios';
import { isNil } from 'lodash-es';

export type SharedAnnotationEmits = {};
export type SharedAnnotationProps = {
	value?: string
	api?: { saveNote (id: number, note: string): Promise<AxiosResponse<void>> }
	id?: number
};

export default class SharedAnnotationSetup extends BaseSetup {

	static readonly defaultProps = {};

	@Reactive private readonly state = { annotation: '' };

	get annotation () { return this.state.annotation }
	set annotation (val: string) { this.state.annotation = val }

	constructor (
		private props: SharedAnnotationProps,
		private emits: SharedAnnotationEmits,
		private _modal?: OrionModal,
	) {
		super();
	}

	protected onMounted () {
		this.state.annotation = this.props.value ?? '';
	}

	async saveAnnotationAsync () {
		if (isNil(this.annotation)) return;

		try {
			if (this.self.readableUserType && this.props.api && this.props.id) {
				await this.props.api.saveNote(this.props.id, this.annotation);
				this._modal?.trigger('updated', this.annotation);
				useNotif.success(this.$t('common.label.annotation'), this.$t('common.annotation.success'));
			}
		}
		catch {
			useNotif.danger(this.$t('common.label.annotation'), this.$t('common.annotation.error'));
		}
	}

}
